import { useFormikContext } from 'formik';
import React from 'react';

import type { AdSelectorVideoCreativeInputV5 as CreativeInput } from '../../../../apis/graphql';
import { CreativeV5Type } from '../../../../apis/graphql';
import Loader from '../../../Loader';
import type { AdFormValues } from '../../adFormik';
import { isCreativeAssetRemoveForbidden } from '../../utils/creative';
import { CreativeFooter, VideoImport } from '../components';
import type { CreativeBuilderProps } from '../CreativeBuilder';
import CreativeBuilder from '../CreativeBuilder';
import { useCreativeData } from '../hooks/useCreativeData';
import type { CreativesBuilderValues } from '../types';

const CLASS_NAME_MODIFIER = 'ad-selector-video';

export const constructAdSelectorVideoCreativeInput = ({
  name,
  video,
  creativeLibraryId,
}: CreativesBuilderValues): CreativeInput => {
  const input: CreativeInput = { name, type: CreativeV5Type.AdSelectorVideo, videoId: video?.id };

  if (creativeLibraryId) input.creativeLibraryId = creativeLibraryId;

  return input;
};

const AdSelectorVideoCreativeBuilder = ({
  editMode,
  adTypeDimensions,
  isPreview,
  ...props
}: CreativeBuilderProps): React.JSX.Element => {
  const {
    values: { creative, lineItem },
  } = useFormikContext<AdFormValues>();

  const {
    data: { assets },
    loading: loadingCreativeData,
  } = useCreativeData(creative, lineItem?.displayPublisherTarget);

  if (loadingCreativeData) return <Loader />;

  return (
    <CreativeBuilder
      lineItemPublishers={lineItem?.displayPublisherTarget || []}
      lineItemCountry={lineItem?.country}
      classNameModifier={CLASS_NAME_MODIFIER}
      editMode={editMode}
    >
      <VideoImport
        builder={{ ...props, editMode, isPreview, adTypeDimensions }}
        allowVast={false}
        readonly={isCreativeAssetRemoveForbidden(editMode, creative)}
      />
      <CreativeFooter assets={assets} creative={creative} isLoading={loadingCreativeData} lineItemData={lineItem} />
    </CreativeBuilder>
  );
};

export default AdSelectorVideoCreativeBuilder;
